export default "__VITE_ASSET__B82C$3ut__";